import { createUseStyles } from "react-jss";
import ContentWrapper from "../ContentWrapper";
import Button from "../Button";
import useMobile from "../../Hooks/useMobile";
import classNames from "classnames";

interface Props {
  header?: string;
  className?: string;
  description?: string;
  backgroundImage?: string;
  coverImage?: string;
  buttonLabel?: string;
  buttonOnClick?: () => void;
}

const useStyles = createUseStyles({
  root: {
    width: "100%",
    backgroundSize: "cover",
    backgroundPosition: "25% 65%",
    minHeight: "440px",
    // zIndex: "1",
    position: "relative",
    "& > Button": {
      alignSelf: "flex-start",
    },
  },
  heroContent: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    width: "61%",
    textAlign: "left",
    padding: "100px 0px",
    "& h1": {
      marginTop: "0px",
    },
    "@media (max-width: 1480px)": {
      padding: "50px 20px",
      width: "fit-content",
    },
  },
  heroHeaderSection: {
    display: "flex",
    flexDirection: "row",
    marginBottom: "30px",
    alignItems: "center",
  },
  line: {
    display: "block",
    top: "58%",
    left: "0%",
    borderBottom: "4px solid #3ABFD3",
    width: "0%",
    textAlign: "center",
    animation: "$line 1.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards",
  },
  heroButton: {
    alignSelf: "flex-start",
    marginTop: "20px",
    display: "inline-block",
  },
  "@keyframes line": {
    from: {
      left: "-100%",
      width: "0%",
    },
    to: {
      left: "0%",
      width: "100%",
    },
  },
  mobileImage: {
    backgroundSize: "contain",
    width: "inherit",
  },
  mobileImageWrapper: {
    position: "relative",
    backgroundSize: "contain",
    width: "inherit",
  },
  coverImage: {
    width: "235px",
    marginRight: "30px",
  },
  mobileCoverImage: {
    position: "absolute",
    top: 0,
    left: 0,
    height: "110%",
    width: "auto",
    transform: "translateX(-50%)",
  },
});

const Hero = ({
  header,
  description,
  backgroundImage,
  coverImage,
  buttonLabel,
  buttonOnClick,
  className,
}: Props) => {
  const classes = useStyles();
  const isMobile = useMobile();
  return (
    <div
      className={classNames(classes.root, className)}
      style={{
        backgroundImage: !isMobile
          ? `linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 33%, rgba(255,255,255,0.8253895308123249) 45%, rgba(255,255,255,0) 100%), url(${backgroundImage})`
          : "none",
      }}
    >
      {isMobile && (
        <div className={classes.mobileImageWrapper}>
          <img
            loading="lazy"
            alt="hero-image"
            className={classes.mobileImage}
            src={backgroundImage}
          />
          <img
            className={classes.mobileCoverImage}
            alt="cover-image"
            src={coverImage}
          />
        </div>
      )}

      <ContentWrapper>
        <div className={classes.heroContent}>
          <div className={classes.heroHeaderSection}>
            {coverImage && !isMobile && (
              <div>
                <img
                  className={classes.coverImage}
                  alt="cover-image"
                  src={coverImage}
                />
              </div>
            )}
            <h1>{header}</h1>
          </div>
          <div>
            <div className={classes.line} />
            <p>{description}</p>
            {buttonLabel && buttonOnClick && (
              <Button
                className={classes.heroButton}
                label={buttonLabel}
                onClick={buttonOnClick}
              />
            )}
          </div>
        </div>
      </ContentWrapper>
    </div>
  );
};

export default Hero;
